import { COUNTRY_LANG_MAP } from "../../../commons/src/lib/models/i18n/country.constant";
import type { IEnvironment } from "../../../commons/src/lib/models/interfaces/environment.interface";
import apiUpstreams from "./api-upstreams.json";
import { MAP_TILES } from "./map-tiles.config";

const API_BASE_URL = `https://${apiUpstreams.production.host}`;

export const environment: IEnvironment = {
  production: true,
  ENABLED_USERS: ["pasilvaar@falabella.cl", "ext_emsuarez@falabella.cl", "ext_rgongoraa@falabella.cl", "gfmoram@falabella.cl", "mandpastorde@falabella.cl", "afperez@falabella.cl"],
  APP_CONFIGURATION: {
    HEADERS: {
      CHREF: "WEB",
      COMMERCE: "FAL",
      CMREF: "SERTEC",
    },
  },
  MAP_TILES,
  BASE_URL: API_BASE_URL,
  APIKEY: "AIzaSyAANQcqJP21k5ZtQvE3npRQ4mqm9z52VDs",
  ENVIRONMENT_BACKEND: "PROD",
  COUNTRY_LANG_MAP: COUNTRY_LANG_MAP,
  DEFAULT_LANG: COUNTRY_LANG_MAP.CL,
  KEYCLOAK: {
    URL: "https://access-key-corp.falabella.tech/auth/",
    CLIENT_ID: "stro-dgsp-sertec",
    REALM: "esti",
  },
  OST: {
    BASE: "/v1/ost",
    LIST: "/list",
    PARAM: "/params",
    CREATE: "/create",
    CONNECT: "/connect",
    EXTENDED: "/extended",
    LEGAL: "/legal",
    PROVIDER: "/provider",
    HISTORICAL: "/historical",
    MAIL_LABELS: "/mail-labels",
    UPDATE_GESTION_PRODUCTO_EXCEL: "/gestion-producto-bulk",
    MANIFESTS: "/manifests",
    EXCEL: "/excel",
  },
  FILE: {
    BASE: "/v1/files",
    UPLOAD: "/upload",
    IMAGES: "/images",
    STORAGE: "/storage",
    MAIL_LABEL: "/mail-label",
    MAIL_MANIFEST: "/mail-manifest",
  },
  WARRANTY: {
    BASE: "/api/warranties",
  },
  ASSET: {
    BASE: "/v1/assets",
  },
  INVOICES: {
    BASE: "/v1/invoices",
    CHANGES_VALID: "/changes/valid",
  },
  STATE_MACHINE: {
    BASE: "/v1/state-machine",
    OST: "/ost/possible-transitions",
  },
  STORES: {
    BASE: "/v1/ost/stores",
  },
  PROVIDER: {
    BASE: "/v1/providers",
  },
  SECURITY: {
    BASE: "/api/security",
    AUTHENTICATE: "/authenticate",
  },
  LOCATION: {
    BASE: "/v1/location",
    COUNTRY: "/country",
  },
  GIFTCARD: {
    BASE: "/v1/giftcards",
    ACTIVATION: "/activation",
    LIST_HISTORICAL: "/list",
    SEND: "/notify",
  },
  SRX: {
    BASE: "/v1/srx",
    STATUS: "/status/f11",
    REGION: "/regiones",
    COMUNA: "/regiones/comunas",
  },
  SEE: {
    BASE: "/v1/see",
    NOTIFICATIONS: "/notifications",
    STREAM: "/stream",
  },
  SOS_WEB_URL: "https://sos-web.falabella.com/sign-in",
  TRANSPORT_PROVIDER_RULES: [
    {
      brand: "HP",
      size: "MINITICKET",
      warrantyType: "GL",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
    {
      brand: "HP",
      size: "MINITICKET",
      warrantyType: "GPR",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
    {
      brand: "EPSON",
      size: "MINITICKET",
      warrantyType: "GL",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
    {
      brand: "EPSON",
      size: "MINITICKET",
      warrantyType: "GPR",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
    {
      brand: "ACER",
      size: "MINITICKET",
      warrantyType: "GL",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
    {
      brand: "ACER",
      size: "MINITICKET",
      warrantyType: "GPR",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
    {
      brand: "ANY",
      size: "MINITICKET",
      warrantyType: "GL",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
    {
      brand: "ANY",
      size: "MINITICKET",
      warrantyType: "GPR",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
    {
      brand: "ANY",
      size: "MINITICKET",
      warrantyType: "GE",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
    {
      brand: "ANY",
      size: "MINITICKET",
      warrantyType: "GC",
      metropolitanRegion: { provider: "Correos de Chile", valueParam: "60503000" },
      otherRegions: { provider: "Correos de Chile", valueParam: "60503000" },
    },
  ],
  PERMITTED_CORREOS_DE_CHILE_STORE: ["*"],
};
